var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base"},[_c('navbar'),_c('b-container',{staticClass:"main_box"},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }